import SideBySideTabsAndProcessTabsConfig from "./side-by-side-tabs-and-process-tabs-config";
import SideBySideTabsAndProcessTabsAdvancedConfig from "./side-by-side-tabs-and-process-tabs-advanced-config";
import dynamic from "next/dynamic";
const SideBySideTabsAndProcessTabsComponent = dynamic(()=>import("./side-by-side-tabs-and-process-tabs-component"));
export default {
    SideBySideTabsAndProcessTabsComponent,
    SideBySideTabsAndProcessTabsConfig,
    SideBySideTabsAndProcessTabsAdvancedConfig
};
